import React from 'react';
import './Hero.css';

const Hero = () => {
  return (
    <div className="hero">
      <div className="hero-overlay"></div>
      <div className="hero-content">
        <h1>ADVANCED METAL SHOP </h1>
        <p>Precision Metal Fabrication Excellence</p>
        <a href="/contact" className="cta-button">Get a Quote</a>
      </div>
    </div>
  );
};

export default Hero; 